import React, { PropsWithChildren } from 'react';

interface SubHeadingProps {
    style?: React.CSSProperties
}

const SubHeading = (props: PropsWithChildren<SubHeadingProps>) => <span style = {props.style} className={'ds-u-sans ds-title'} {...props}>{props.children}</span>;

export default SubHeading;